  // Helper function to get Storybook URL safely
export const getStorybookUrl = (): string | null => {
  const baseUrl = process.env.REACT_APP_STORYBOOK_BASE_URL;
  return baseUrl ? `${baseUrl}/?path=/docs/foundation-content-design--page` : null;
};
